import type { Profile } from "@kedaat/engine";

export const PROFILE_STATUS_LABEL: Record<Profile["status"], string> = {
  draft: "טיוטה – טרם אומת",
  partial: "חלקי – טרם אומת",
  verified: "מאומת",
};
